import { Directive, ElementRef, HostListener, Input, OnInit, Renderer2 } from '@angular/core';
import { CxTableService } from '../services/cx-table.service';

@Directive({
  selector: '[cxEditColumn]'
})
export class ColumnEditDirective implements OnInit {
  @Input() cxEditColumn: any = null;
  @Input() cxEditColumnRow: any = null;

  constructor(private el: ElementRef, private tableServive: CxTableService) {
    this.el.nativeElement.onclick = () => {
      this.tableServive.showEditColumnModal = true;
      this.tableServive.editColumn = { column: this.cxEditColumn, row: this.cxEditColumnRow }; 
    }
  }
  ngOnInit(): void {}
}